(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9185],{

/***/ 4704:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blockquiry_connect/u",
      function () {
        return __webpack_require__(45106);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ u; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _select_agency__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62174);
/* harmony import */ var _message_app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45581);
/* eslint-disable no-unused-vars */ 


function u() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("selectAgency", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("messageApp", {})
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3517,4540,3835,1816,5426,877,517,2390,3408,9073,8346,594,7155,6401,1199,112,7929,2227,9407,4705,12,2174,9774,2888,179], function() { return __webpack_exec__(4704); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);